<template>
  <div>
    <md-layout
      v-if="certificationProcess.status <= 6"
      key="syncInformations"
    >
      <md-layout
        md-column
        v-if="queueStatus === 'creating'"
      >
        <span class="md-title">CARREGANDO INFORMAÇÕES</span>
        <span class="md-caption">Esta é a ultima etapa do processo de certificação do banco de leite
          humano, nesta etapa você precisa manter o WI-FI do seu celular ligado
          até que o envio esteja concluído.</span>
        <span class="md-caption">{{ queueLog }}</span>
        <md-progress md-indeterminate></md-progress>
      </md-layout>
      <md-layout
        md-column
        v-else-if="queueStatus === 'waiting'"
      >
        <span class="md-title">ENVIO DAS INFORMAÇÕES</span>
        <span class="md-caption">Esta é a ultima etapa do processo de certificação do banco de leite
          humano, nesta etapa você precisa manter o WI-FI do seu celular ligado
          até que o envio esteja concluído.</span>
        <md-button
          class="md-accent md-raised"
          @click="startQueue" :disabled="!networkStatus"
        >Iniciar a Sincronização
        </md-button>
      </md-layout>
      <md-layout
        md-column
        v-else-if="queueStatus === 'running'"
      >
        <span class="md-title">ENVIANDO FOTOS PARA NUVEM</span>
        <span class="md-caption">Durante esse processo mantenha o aplicativo aberto e WI-FI
          ligado.</span>
        <md-progress
          :md-size="150"
          :md-progress="progress"
          class="md-warn"
        ></md-progress>
        <p>
          {{ queueLog }} <br />
          Total: {{ queue.size }} Pendente: {{ queue.pending }}<br />
          Area Atual: {{ currentArea }}<br />
          Item Atual: {{ currentItem }}<br />
          Foto Atual: {{ currentPhoto }}
        </p>
      </md-layout>
      <md-layout
        md-column
        v-else-if="queueStatus === 'error'"
      >
        <span class="md-title">OCORREU UM ERRO AO ENVIAR OS DADOS PARA A NUVEM!</span>
        <span class="md-caption">Verifique os motivos abaixo antes de tentar novamente.</span>
        <md-list class="custom-list md-triple-line">
          <md-list-item v-for="(object,key) in faultyPhotos">
            <div class="md-list-text-container">
              <span>{{ object.item.name }}</span>
              <span class="caption">FOTO: {{ object.photo.name }}</span>
              <p>{{ object.error }}</p>
            </div>
            <md-button class="md-icon-button md-list-action" @click="captureNewPhoto(object)">
              <md-icon class="md-primary">upload_file</md-icon>
            </md-button>
            <md-divider class="md-inset"></md-divider>
          </md-list-item>
          <md-list-item v-if="blueprintError != ''">
            <div class="md-list-text-container">
              <span>PLANTA BAIXA DO BLH</span>
              <p>{{ blueprintError }}</p>
            </div>
            <md-button class="md-icon-button md-list-action" @click="captureNewBlueprint()">
              <md-icon class="md-primary">upload_file</md-icon>
            </md-button>
            <md-divider class="md-inset"></md-divider>
          </md-list-item>
        </md-list>
        <md-button
          class="md-accent md-raised"
          @click="restartQueue" :disabled="!networkStatus"
        >Tentar a Sincronização Novamente
        </md-button>
      </md-layout>
    </md-layout>
    <md-layout
      v-else
      md-column
    >
      <span class="md-title">Parabéns!
        <b>{{ blh.name }}</b>
      </span>
      <span class="md-title">CERTIFICAÇÃO {{ blh.currentYear }} ENVIADA COM SUCESSO!</span>
      <span class="md-caption">Seu processo está em fase de análise, qualquer dúvida entre em contato
        conosco</span>
    </md-layout>
    <md-snackbar
      md-position="bottom center"
      ref="snackbar"
      :md-duration="Infinity"
    >
      <span>Sem conexão com a internet! Conecte a uma rede wi-fi e tente novamente.</span>
    </md-snackbar>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import PQueue from 'p-queue'

const logRequests = true // process.env.DEBUG_MODE
export default {
  name: 'sync-queue',
  data() {
    return {
      queueStatus: 'creating',
      queueLog: '',
      currentArea: '',
      currentItem: '',
      currentPhoto: '',
      progress: 0,
      totalItems: 0,
      faultyPhotos: [],
      blueprintError: '',
      queue: { type: PQueue },
      finishedWithoutErrors: true,
      networkStatus: true
    }
  },
  computed: {
    ...mapState({
      certificationProcess: state => state.certificationProcess,
      blh: state => state.blh,
      uid: state => state.uid
    })
  },
  beforeMount() {
    window.addEventListener('online', () => {
      this.handleConnectivityChange()
    })
    window.addEventListener('offline', () => {
      this.handleConnectivityChange()
    })
    this.networkStatus = navigator.onLine
    this.FETCH_DATA().then(() => {
      this.$nextTick(() => {
        if (this.certificationProcess.status <= 6) {
          this.createQueue()
        }
      })
    })
  },
  beforeDestroy() {
    window.removeEventListener('online', this.handleConnectivityChange)
    window.removeEventListener('offline', this.handleConnectivityChange)
    if (this.queue.constructor === PQueue) {
      this.queue.pause()
      this.queue.clear()
    }
  },
  updated() {
    if (!this.networkStatus) {
      this.$refs.snackbar.open()
    }
  },
  methods: {
    ...mapActions([
      'FETCH_DATA',
      'FETCH_IMAGE',
      'UPLOAD_FILE',
      'PHOTO_SYNC',
      'SYNC_PROCESS',
      'SET_PROCESS',
      'GOTO_STEP'
    ]),
    restartQueue() {
      logRequests && console.log('[Queue Restarted]')
      if (this.queue.constructor === PQueue) {
        this.queue.pause()
        this.queue.clear()
      }
      this.createQueue()
      this.queueStatus = 'waiting'
    },
    startQueue() {
      logRequests && console.log('[Queue Started]')
      this.queueStatus = 'running'
      this.queue.start()
    },
    createQueue() {
      this.faultyPhotos = []
      this.queueStatus = 'creating'
      this.queue = new PQueue({ concurrency: 4, autoStart: false })
      logRequests && console.log('Creating Queue...')
      let count = 0

      this.queue.on('active', () => {
        this.queueLog = `Trablhando no item #${++count}. Total: ${this.queue.size
        } Pendente: ${this.queue.pending}`
        this.progress = parseInt((count / this.totalItems) * 100, 10)
        logRequests && console.log(this.queueLog)
      })

      this.queue.on('error', error => {
        this.queueStatus = 'error'
        this.queueLog = 'Envio finalizado com erros.'
        this.finishedWithoutErrors = false
        console.log(error)
      })

      this.queueAreas()
      this.queue.onIdle().then(() => {
        // console.log(this.faultyPhotos)
        this.queueLog = 'Enviando dados da planta.'
        this.uploadBluePrint().then((fileUrl) => {
          if (this.finishedWithoutErrors && this.faultyPhotos.length <= 0) {
            this.SYNC_PROCESS(fileUrl).then(() => {
              this.queueLog = 'Envio finalizado.'
              this.queueStatus = 'complete'
            })
          } else {
            this.queueStatus = 'error'
            this.queueLog = 'Envio finalizado com erros.'
          }
        }).catch(error => {
          this.blueprintError = error
          this.queueStatus = 'error'
          this.queueLog = 'Envio finalizado com erros.'
        })
      })

      logRequests &&
      console.log(`[Queue created with ${this.queue.size} items pending]`)
    },
    queueAreas() {
      var vm = this
      logRequests &&
      console.log(`Queuing areas ${vm.certificationProcess.areas.length}`)

      for (
        let areaIndex = 0;
        areaIndex < vm.certificationProcess.areas.length;
        areaIndex++
      ) {
        let area = vm.certificationProcess.areas[areaIndex]
        if (area.status !== 2) {
          vm.queueLog = `Carregando Area A${areaIndex + 1} ${area.name}`

          vm.queueAreaStructureUpload(area, areaIndex)
          vm.queueAreaVerticeUpload(area, areaIndex)
        }
      }

      this.queueLog = 'Areas carregadas com sucesso...'
      this.totalItems = this.queue.size
      this.queueStatus = 'waiting'
    },
    queueAreaStructureUpload(area, areaIndex) {
      var vm = this
      if (!area.structures) {
        logRequests && console.warn(`Area without structures ${area.name}`)
        return Promise.resolve() // This is normal, we dont throw an error here.
      }

      for (
        let structureIndex = 0;
        structureIndex < area.structures.length;
        structureIndex++
      ) {
        let structure = area.structures[structureIndex]
        if (!structure || !structure.photos) {
          logRequests &&
          console.warn(
            `Structures structureIndex:${structureIndex} null or dont have photos`
          )
          continue // This is not supposed to happen...
        }
        vm.queuePhotoUpload(structure, area, structureIndex, areaIndex)
      }
    },
    queueAreaVerticeUpload(area, areaIndex) {
      var vm = this
      if (!area.vertices) {
        logRequests && console.warn(`Area without vertices ${area.name}`)
        return Promise.resolve() // This is not supposed to happen...
      }
      for (
        let verticeIndex = 0;
        verticeIndex < area.vertices.length;
        verticeIndex++
      ) {
        let vertice = area.vertices[verticeIndex]
        if (!vertice || !vertice.photos) {
          logRequests &&
          console.warn(
            `Vertice verticeIndex:${verticeIndex} null or dont have photos`
          )
          continue
        }
        vm.queuePhotoUpload(vertice, area, verticeIndex, areaIndex)
      }
    },
    // queueBlueprintUpload () {

    // },
    // queueAlvaraUpload () {
    //   return Promise.resolve()
    // },
    queueCertificationSync() {
      return Promise.resolve()
    },
    queuePhotoUpload(item, area, itemIndex, areaIndex) {
      var vm = this
      logRequests &&
      console.log(
        `Queueing ${item.photos.length} photos for ${area.name}-${item.name}`
      )

      if (!item.photos) {
        // Checking for nulls again just to be sure
        logRequests &&
        console.warn(`Item without photos: ${item.name}-${area.name}`)
        return Promise.resolve()
      }

      for (let photoIndex = 0; photoIndex < item.photos.length; photoIndex++) {
        let photo = item.photos[photoIndex]
        if (!photo) {
          logRequests &&
          console.warn(
            `Photos is empty: [${photoIndex}] ${item.name}-${area.name}`
          )
          return Promise.reject(
            `Photos is empty: [${photoIndex}] ${item.name}-${area.name}`
          )
        }
        // If photo has not been synced yet
        if (photo.status !== 2) {
          vm.queue.add(() =>
            vm.upload(photo, area, item, photoIndex, itemIndex, areaIndex)
          )
        }
      }
    },
    uploadBluePrint() {
      if (this.certificationProcess.blueprintUrl) {
        return Promise.resolve(this.certificationProcess.blueprintUrl)
        // return this.SYNC_PROCESS(this.certificationProcess.blueprintUrl)
      } else {
        return this.FETCH_IMAGE(this.certificationProcess.blueprint)
          .then(imgBlob => {
            let fileName = `${this.blh.currentYear}_${this.blh.id}_${this.certificationProcess.blueprint}.jpg`
            return this.UPLOAD_FILE({
              image: new File([imgBlob], fileName),
              name: fileName
            })
            // .then(fileUrl => {
            //   this.SYNC_PROCESS(fileUrl)
            // })
          })
          .catch(err => {
            this.finishedWithoutErrors = false
            console.log(err)
            return Promise.reject(err)
          })
      }
    },
    // uploadAlvara () {

    // },
    upload(photo, area, item, photoIndex, itemIndex, areaIndex) {
      var vm = this

      if (!photo) {
        this.faultyPhotos.push({
          'area': area,
          'item': item,
          'photo': photo,
          'itemIndex': itemIndex,
          'areaIndex': areaIndex,
          'photoIndex': photoIndex,
          'error': `O item ${item.name} não existe`
        })
        return Promise.reject(`Item ${item.name} photo is null`)
      }

      if (!photo.image) {
        this.faultyPhotos.push({
          'area': area,
          'item': item,
          'photo': photo,
          'itemIndex': itemIndex,
          'areaIndex': areaIndex,
          'photoIndex': photoIndex,
          'error': `A foto do item ${item.name} não existe`
        })
        return Promise.reject(
          `Item ${item.name} photo ${photo.name} image is null`
        )
      }

      return this.FETCH_IMAGE(photo.image).then(imgBlob => {
        let error = ''
        if (!imgBlob) {
          error = `O objeto não existe ou está corrompida.`
          logRequests && console.warn(error)
          this.faultyPhotos.push({
            'area': area,
            'item': item,
            'itemIndex': itemIndex,
            'areaIndex': areaIndex,
            'photoIndex': photoIndex,
            'photo': photo,
            'error': error
          })
          return Promise.reject(error)
        }

        vm.currentArea = area.name
        vm.currentItem = item.name
        vm.currentPhoto = photo.name

        let fileName = `${vm.blh.currentYear}_${vm.uid}_${photo.image}.png`
        let file = new File([imgBlob], fileName)
        logRequests &&
        console.log(
          `Uploading file: ${fileName}.jpg with size: ${file.size}`
        )
        return vm.UPLOAD_FILE({ image: file, name: fileName }).then(fileUrl => {
          logRequests &&
          console.log(
            `File uploaded: ${fileName}.jpg with size: ${file.size}`
          )
          return vm.PHOTO_SYNC({
            photoId: photoIndex,
            areaId: areaIndex,
            itemId: itemIndex,
            type: item.type,
            status: 2,
            image: photo.image,
            url: fileUrl
          })
        })
      }).catch((error) => {
        console.log(`${error}`)
        this.faultyPhotos.push({
          'area': area,
          'item': item,
          'itemIndex': itemIndex,
          'areaIndex': areaIndex,
          'photoIndex': photoIndex,
          'photo': photo,
          'error': error
        })
        return Promise.reject(error)
      })
    },
    handleConnectivityChange() {
      this.networkStatus = navigator.onLine
      logRequests && console.log('handleConnectiveChange:' + this.networkStatus)
      if (this.networkStatus) {
        this.$refs.snackbar.close()
      } else {
        this.queue.pause()
        this.queueStatus = 'waiting'
        this.$refs.snackbar.open()
      }
    },
    captureNewPhoto(objectItem) {
      this.$router.push({
        name: 'Camera',
        params: {
          area: objectItem.areaIndex,
          structureKey: objectItem.itemIndex,
          type: objectItem.item.type
        }
      })
    },
    captureNewBlueprint() {
      this.$set(this.certificationProcess, 'status', 5)
      this.SET_PROCESS(this.certificationProcess).then(() => {
        this.GOTO_STEP(0)
      })
    }
  }
}
</script>
<style scoped>
.md-spinner {
  position: absolute;
  top: 50%;
  left: 28px;
  transform: translate(-50%, -50%);
}

.md-title {
  text-align: center;
}

.md-caption {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// SyncQueue.vue?786a7542